import classNames from 'classnames';
import React from 'react';
import styles from './list-item-layout.module.css';
export function ListItemLayout(props) {
    var _a;
    return (React.createElement("li", { className: classNames(styles.listItemLayoutChildren, (_a = {}, _a[styles.clickable] = !props.disabled && !!props.onClick, _a[styles.disabled] = props.disabled, _a), "kplr_listItemLayoutChildren"), onClick: props.disabled ? void 0 : props.onClick },
        props.children,
        !!props.onClick && React.createElement("span", { className: styles.cardListItemArrow })));
}
export default ListItemLayout;
